import * as IoC from 'typescript-ioc';
import { JobConfiguration } from '../../job-configuration';
import { JobType } from '../../../../api/jobs.dao';
import { IMeetingsDAO } from '../../../../api/meetings.dao';

export class MeetingsCancelJob extends JobConfiguration {
    public readonly type = JobType.MeetingsCanceling;
    public readonly name = 'Bulk Cancel Meetings';
    public readonly description = 'Meetings Cancellation';

    public async execute(execParams) {
        return IoC.Container.get(IMeetingsDAO).cancelMeetingsByStartDateTimes(execParams);
    }
}

export default {
    [JobType.MeetingsCanceling]: MeetingsCancelJob
};
